import dynamic from "next/dynamic";
import { useFormContext } from "react-hook-form";

const PlacesSearchBox = dynamic(
  () => import("components/maps/search/PlacesSearchBox/PlacesSearchBox")
);
import styles from "./PlacesSearch.module.scss";
import { useEffect } from "react";
import { formatGooglePlaceDetails } from "utils/map/place-data";

export default function PlacesSearch({
  id,
  onChange = () => {},
  portalRef,
  register,
}) {
  const { trigger, setError, setValue, getValues } = useFormContext() ?? {};

  useEffect(() => {
    const currentValue = getValues(id);

    if (!currentValue) {
      setValue(id, null);
    }
  }, [getValues, id, setValue]);

  const handleSearchBlur = () => {
    const currentValue = getValues(id);

    // if (!currentValue?.country?.name && !currentValue?.name) {
    //   setValue(null);
    // }

    if (!currentValue) {
      setError(id, { type: "required", message: "Please select a location" });
    }
  };

  const handleSearchChange = async (searchValue) => {
    if (searchValue === "" || !searchValue || searchValue.length === 0) {
      onChange(id, null);

      setValue(null);

      trigger ? trigger(id) : "";
    }
  };

  const handleSearchRetrieve = async (result) => {
    const placeData = formatGooglePlaceDetails({ placeDetails: result });

    // !!onChange ? onChange(placeData) : "";
    setValue(id, placeData);

    trigger ? trigger(id) : "";
  };

  return (
    <div className={`${styles.container}`}>
      <PlacesSearchBox
        onChange={handleSearchChange}
        // onSuggest={handleSearchSuggest}
        onRetrieve={handleSearchRetrieve}
        onBlur={handleSearchBlur}
        initialSearchTerm={getValues(id)?.formatted_place}
        suggestionListPortal={portalRef}
      />
    </div>
  );
}
